export enum ProfilingResult {
  ALLOW = 'ALLOW',
  BLOCK = 'BLOCK',
  REQUIRE_LANGUAGE_CONFIRMATION = 'REQUIRE_LANGUAGE_CONFIRMATION',
}
